import React from 'react';
import { Box } from '@mui/material';

export default function BoxGrayContainer({ children, p = 1, ...props }) {
  return (
    <Box p={p} {...props} sx={{ backgroundColor: (theme) => theme.palette.grey[200], ...props.sx }}>
      {children}
    </Box>
  );
}
